// extracted by mini-css-extract-plugin
export var compact = "DashboardMenu-module--compact--rlIjl";
export var content = "DashboardMenu-module--content--z-+FZ";
export var description = "DashboardMenu-module--description--6xk4l";
export var icon = "DashboardMenu-module--icon--9YLTv";
export var link = "DashboardMenu-module--link--QgzqC";
export var list = "DashboardMenu-module--list--razSk";
export var primary = "DashboardMenu-module--primary--wtqiA";
export var secondary = "DashboardMenu-module--secondary--5mKYA";
export var symbol = "DashboardMenu-module--symbol--DWmDf";
export var title = "DashboardMenu-module--title--Uvs8C";